import { Contact } from "@/components/Contact";
import { InstagramFeed } from "@/components/InstagramFeed";
import { useSEO } from "@/lib/useSEO";

export const ContactPage = () => {
  useSEO({
    title: "Contact Us",
    description: "Get in touch with Annapurna Home Pickles — call, WhatsApp, or send us a message. We're based in Rajahmundry, Andhra Pradesh.",
  });
  return (
    <>
      <InstagramFeed />
      <Contact />
    </>
  );
};
